import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RelatedPostList from '../Components/RelatedPost';
import BlogShare from '../Components/BlogShare';
import TagItems from '../Components/TagItems';
import PrevNextPost from '../Components/PrevNextPost';
import AuthorBio from '../Components/AuthorBio';
import BlogSidebar from '../Components/BlogSidebar';
import Loader from '../Components/Loader';
import { GetPostBySlug } from '../services/apiservice';
import { useParams } from 'react-router-dom';

const BlogDetail = () => {
  const [blogPost, setBlogPost] = useState(null);
  const [blogURL, setBlogURL] = useState('');
  const { paramlink } = useParams();
  const [loading, setLoading] = useState(true);

  const fillBlogDetail = async () => {
    try {
      setBlogURL(window.location.href);
      const postdetail = await GetPostBySlug(paramlink);
      const jsonPostDetail = JSON.parse(postdetail);
      setBlogPost(jsonPostDetail);
    } catch (error) {
      console.error('Error fetching the data:', error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fillBlogDetail();
  }, [paramlink]);

  return (
    <div>
      <Helmet>
        {/* Dynamic image/author data from API - not available in static meta-config */}
        {blogPost && (
          <>
            <meta property="og:image" content={blogPost.mediapath} />
            <meta name="twitter:image" content={blogPost.mediapath} />
            <meta name="author" content={blogPost.author || 'Data Beautifier'} />
            <meta name="publish_date" content={blogPost.posteddate} />
            <meta name="article:published_time" content={blogPost.posteddate} />
          </>
        )}
      </Helmet>

      <Header />
      
      {loading ? (
        <Loader />
      ) : blogPost ? (
        <section className="blog-area blog-section blog-details-area ptb-20">
          <div className="container-block-fluid">
            <div className="row">
              <div className="full-col col-lg-8 col-12">
                <div className="blog-details-left-area">
                  <div className="blog-details-single-post" data-aos="fade-up" data-aos-duration="1400">
                    <div className="blog-details-img">
                      <img src={blogPost.mediapath} alt={blogPost.title} />
                    </div>
                    <ul>
                      <li><i className="bx bx-time"></i> {blogPost.posteddate}</li>
                      <li>
                        <a href="#">
                          <i className="bx bx-street-view"></i>
                          {blogPost.views}
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="bx bx-comment"></i>
                          {blogPost.readtime} mins read
                        </a>
                      </li>
                    </ul>
                    <div className="tag-items pb-20">
                      <TagItems postSlug={paramlink} />
                    </div>
                    <h3>{blogPost.title}</h3>
                    <div className='dropcap-paragraph' dangerouslySetInnerHTML={{ __html: blogPost.description }} />
                  </div>

                  <div className="blog-details-sheare" data-aos="fade-up" data-aos-duration="2000">
                    <BlogShare blogURL={blogURL} />
                  </div>

                  <div className="prev-next" data-aos="fade-up" data-aos-duration="2200">
                    <PrevNextPost postSlug={paramlink} />
                  </div>

                  <div className="profile" data-aos="fade-up" data-aos-duration="2400">
                    <AuthorBio postData={blogPost} />
                  </div>

                  <RelatedPostList postSlug={paramlink} />
                </div>
              </div>
              <div className="full-col col-lg-4 col-12">
                <BlogSidebar />
              </div>
            </div>
          </div>
        </section>
      ) : (
        <div className="container ptb-20">
          <p>Blog post not found.</p>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default BlogDetail;
